module.exports = __webpack_public_path__ + "media/images/abvtex-fb373c3c8518d5f3c60f43b16284abfc.jpg";